import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"

export function LanguageToggle() {
  const { i18n } = useTranslation()

  const toggleLanguage = () => {
    const next = i18n.language === "en" ? "zh" : "en"
    i18n.changeLanguage(next)
  }

  return (
    <Button variant="outline" size="sm" onClick={toggleLanguage}>
      {i18n.language === "en" ? "中文" : "EN"}
    </Button>
  )
}
